import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { DEFAULT_COLORS } from 'constants/colors';

const AttachmentFileIcon = ({ backgroundColor, fill, height, width, viewBox, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <defs>
                <polygon points="0 0.0104921875 19.9590062 0.0104921875 19.9590062 34 0 34" />
                <polygon points="0.152583333 0.0395 0.48575 0.0395 0.48575 0.272539129 0.152583333 0.272539129" />
                <polygon points="0.155833333 0.00601390598 0.489 0.00601390598 0.489 0.25 0.155833333 0.25" />
            </defs>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g fill="#D8D8D8" fillOpacity="0">
                    <rect x="0" y="0" width={width} height={height} />
                </g>
                <g transform="translate(19.897482, 21.223839) rotate(-330.000000) translate(-19.897482, -21.223839) translate(9.397482, 3.223839)">
                    <g transform="translate(0.602518, 0.776161)">
                        <mask fill={fill}>
                            <use xlinkHref="#path-1" />
                        </mask>
                        <g />
                        <path
                            d="M8.87807453,34 C8.65509317,33.8454063 8.39099379,33.8717695 8.14658385,33.8218984 C3.85124224,32.9452031 0.615714286,29.2919961 0.0760248447,24.6885156 C0.0298136646,24.2944609 0.0047826087,23.8946953 0.00434782609,23.4975859 C-0.000807453416,18.519375 -0.000559006211,13.5412305 0.000931677019,8.56301953 C0.00118012422,7.84882031 0.418198758,7.27201562 1.02322981,7.12598828 C1.62950311,6.9795625 2.25801242,7.30435547 2.52204969,7.90400391 C2.6347205,8.15980078 2.65509317,8.43359375 2.65496894,8.71269922 C2.65354037,11.9208516 2.65397516,15.1290039 2.65403727,18.3372227 C2.65403727,20.0076719 2.64360248,21.6781875 2.6563354,23.3485703 C2.68459627,27.0796719 4.98049689,30.14525 8.36049689,30.9833633 C12.4471429,31.9967227 16.6278261,28.8835977 17.1465217,24.4474609 C17.191677,24.0616406 17.211677,23.6765508 17.2118012,23.2898672 C17.2135404,18.1567969 17.2168323,13.0237266 17.2111801,7.89065625 C17.2086957,5.57945312 15.9008075,3.68660937 13.887205,3.04585547 C10.97,2.1175625 7.96658385,4.45971094 7.95285714,7.71102734 C7.93291925,12.4568164 7.94416149,17.2028047 7.94919255,21.9486602 C7.95043478,23.1421133 8.84229814,24.0902617 9.93310559,24.0897969 C11.0247826,24.089332 11.916087,23.1428438 11.9177019,21.9488594 C11.9235404,17.5017656 11.9193789,13.0545391 11.9209317,8.60737891 C11.9212422,7.69575391 12.4990062,7.07113672 13.3040994,7.10088672 C13.9180745,7.12353125 14.425528,7.58897266 14.5373913,8.24015234 C14.5615528,8.38060156 14.5729193,8.5255 14.5729814,8.66833984 C14.5747205,13.071207 14.5798137,17.474207 14.572236,21.8770742 C14.5681366,24.2273906 13.1375776,26.2157266 11.0840373,26.7629805 C8.11658385,27.5537461 5.30664596,25.2125273 5.29639752,21.9110078 C5.28186335,17.2205352 5.29086957,12.5299297 5.29465839,7.83932422 C5.29521739,7.09610547 5.39130435,6.36497266 5.58223602,5.64685547 C6.37161491,2.67922656 8.79795031,0.455480469 11.6718634,0.0749726562 C11.7203727,0.06853125 11.7775155,0.0822773437 11.7960248,0.0104921875 L12.044472,0.0104921875 C12.0858385,0.0522617187 12.127205,0.0522617187 12.1686335,0.0104921875 L13.2861491,0.0104921875 C13.6591304,0.0903125 14.042795,0.0603632812 14.4159006,0.161765625 C17.3469565,0.958175781 19.5635404,3.6794375 19.9012422,6.89423047 C19.939441,7.25846875 19.9555901,7.62084766 19.955528,7.98601563 C19.9549068,13.119418 19.9665839,18.2528867 19.9504348,23.3862891 C19.9418634,26.0938711 19.0856522,28.4736055 17.3998137,30.5029805 C15.9436025,32.2558398 14.1373292,33.3662852 11.9967702,33.8625391 C11.6232919,33.9490664 11.2393168,33.9280156 10.8647826,34 L10.6785093,34 C10.6164596,33.9502617 10.5543478,33.9502617 10.4922981,34 L9.31267081,34 C9.27130435,33.9582305 9.22987578,33.9582305 9.18850932,34 L8.87807453,34 Z"
                            fill={backgroundColor}
                            mask="url(#mask-2)"
                        />
                    </g>
                    <path
                        d="M11.5090079,34.8261613 C11.5713274,34.7162508 11.6337092,34.6712874 11.6960287,34.8261613 L11.5090079,34.8261613 Z"
                        fill="#626262"
                    />
                    <g transform="translate(13.602518, 0.776161)">
                        <mask fill={fill}>
                            <use xlinkHref="#path-3" />
                        </mask>
                        <g />
                        <path
                            d="M0.48575,0.03955 C0.374583333,0.29305 0.263583333,0.36005 0.152583333,0.03955 L0.48575,0.03955 Z"
                            mask="url(#mask-4)"
                        />
                    </g>
                    <g transform="translate(9.602518, 34.776161)">
                        <mask fill={fill}>
                            <use xlinkHref="#path-5" />
                        </mask>
                        <g />
                        <path
                            d="M0.155833333,0.25 C0.266833333,-0.10275 0.378,-0.02975 0.489,0.25 L0.155833333,0.25 Z"
                            mask="url(#mask-6)"
                        />
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

AttachmentFileIcon.propTypes = {
    backgroundColor: string,
    fill: string,
    height: string,
    width: string,
    viewBox: string,
};

AttachmentFileIcon.defaultProps = {
    backgroundColor: DEFAULT_COLORS.ORANGE,
    fill: DEFAULT_COLORS.WHITE,
    height: '25',
    width: '25',
    viewBox: '0 0 50 50',
};

export default AttachmentFileIcon;
